import React from 'react';
import classnames from 'classnames';
import Ellipsis from '@wix/da-ds/pkg/Icons/Ellipsis';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import UserIdentityLargeMobile from '../../../../../User/IdentityLargeMobile';
import ThumbActions from '../../../../Helper/ThumbActions';
import { useOverlayContext } from '../../../../hooks/useOverlayContext';
import TopInfoBarWatchButton from './TopInfoBarWatchButton';
import s from './TopInfoBar.scss';
const TopInfoBar = ({ deviation, extraActions, className })=>{
    const { showAuthorWatchButton } = useOverlayContext(deviation);
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['root'], className)
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['left']
    }, /*#__PURE__*/ React.createElement(UserIdentityLargeMobile, {
        user: deviation.author,
        deviation: deviation,
        className: s['author']
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['right']
    }, showAuthorWatchButton && /*#__PURE__*/ React.createElement(TopInfoBarWatchButton, {
        deviation: deviation
    }), extraActions && /*#__PURE__*/ React.createElement(ThumbActions, {
        className: s['actions'],
        actions: extraActions,
        deviation: deviation
    }, /*#__PURE__*/ React.createElement(Ellipsis, {
        size: IconSize.MEDIUM,
        disableDefaultColors: true
    }))));
};
TopInfoBar.displayName = 'TopInfoBar';
export default TopInfoBar;

//# sourceMappingURL=TopInfoBar.js.map